export default {
  methods: {
    async showGenericErrorModal() {
      await this.$bvModal.msgBoxOk(
        'Uh-oh, we don\'t know what to do about this error that just happened. Refresh the page to try to set things right.',
        {
          title: 'Something went wrong',
          okTitle: 'Refresh'
        }
      );
      location.reload();
    }
  }
}
